import { createAction, props } from '@ngrx/store';
import { Message } from 'src/app/common/messages';

export const addMessage = createAction(
    '[Messages] Add Message',
    props<{ message: Message }>()
  );

export const removeMessage = createAction(
    '[Messages] Remove Message',
    props<{ message: Message }>()
);

export const loadUserInfo = createAction(
  '[Dashboard API] Load User Info',
  //props<{ userInfo: any }>()
);

//Api actions
export const loadUserInfoSuccess = createAction(
  '[Dashboard API] Load User Info Success',
  props<{ userInfo: any }>()
);

export const loadFailure = createAction(
  '[Dashboard API] Load Fail',
  props<{ error: string }>()
);
